import { render, staticRenderFns } from "./RmpSignIn.vue?vue&type=template&id=8488cb08&scoped=true"
import script from "./RmpSignIn.vue?vue&type=script&setup=true&lang=ts"
export * from "./RmpSignIn.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./RmpSignIn.vue?vue&type=style&index=0&id=8488cb08&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8488cb08",
  null
  
)

export default component.exports